import { render } from "./LifeHackResources.vue?vue&type=template&id=62721510"
import script from "./LifeHackResources.vue?vue&type=script&lang=js"
export * from "./LifeHackResources.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__